import React, { useState } from 'react';
import { Film, Play } from 'lucide-react';
import './ProjectsOrbit.css';

const ASSETS = 'https://customer-assets-wrfwihn1.emergentagent.net/job_c48739c8-01fe-4eac-8344-d77f44a771b1/artifacts';

export const PROJECTS = [
  {
    id: 'miningrace',
    title: 'Mining Race',
    image: `${ASSETS}/aefvgg8r_MR.jpg`,
    video: 'https://youtu.be/RXseJ4kQUv8',
    videoTitle: 'Mining Race Explainer Video',
    description: `Mining Race ist eine innovative Plattform, die dir exklusiven Zugang zum Bitcoin-Mining direkt über eine benutzerfreundliche App ermöglicht.
Egal ob du eigenständig starten oder gemeinsam im Team wachsen möchtest – hier sind beide Wege möglich. Dabei wird echter Bitcoin geschürft und gleichzeitig die Grundlage für ein nachhaltiges, passives Einkommen geschaffen.`,
  },
  {
    id: 'nwp',
    title: 'NWP',
    image: `${ASSETS}/q12bogzi_NWP.jpg`,
    video: 'https://youtu.be/_tCiua9H0q8',
    videoTitle: 'NETWORK PROFITS | NWP',
    description: `NWP hat sich zum Ziel gesetzt, eine einfache Plattform anzubieten, in der Du deine Cryptos professionellen Tradern zur Verfügung stellst um regelmäßige, planbare und verlässliche wöchentliche Einnahmen zu erhalten – und das, während das investierte Kapital flexibel verfügbar bleibt. Von automatisierten Handelsstrategien in Märkten wie Öl, Gold, Silber und Forex bis hin zu verschiedenen Portfolio-Stufen und einem fairen 50/50-Gewinnteilungsprinzip bietet das Projekt spannende Ansätze für unsere Community.
NWP ermöglicht die Beteiligung an einer automatisierte Einkommensstrategien!`,
  },
  {
    id: 'utopia',
    title: 'Utopia',
    image: `${ASSETS}/tflvf75v_Utopia.jpg`,
    video: 'https://youtu.be/ItLKI3t_Uf0',
    videoTitle: 'UTOPIA',
    description: `🏦 Endlich: Die Banken-Revolution, auf die wir gewartet haben!
Stell dir vor, eine Bank würde erst 5 Jahre lang im Hintergrund alle Lizenzen sichern, bevor sie überhaupt an die Öffentlichkeit geht. Genau das ist bei Utopia passiert – und wir sind jetzt in der absolut heißesten Phase!
🚀 Was macht dieses Projekt so besonders?
✔️ Fundament statt Hype: Die Firma wurde bereits vor 5 Jahren gegründet. Hier wurde erst geliefert und lizenziert, bevor Marketing gemacht wurde.
✔️ Maximale Sicherheit: Sogar im extrem strengen japanischen Markt zugelassen und SEC-zertifiziert. Das ist das "Gold-Level" der Compliance.
✔️ Echte Freiheit: Weg vom klassischen Banksystem, hin zur Eigenverantwortung. Dein Geld liegt auf dezentralen, non-custodial Wallets. Das bedeutet: Nur DU hast den Schlüssel. Keine Bank kann dein Konto einfrieren.
✔️ Banking trifft Krypto: Eine nahtlose App für dein gesamtes Finanzleben.`,
  },
  {
    id: 'superone',
    title: 'SuperOne',
    image: `${ASSETS}/oo3hftnu_Superone.jpg`,
    video: 'https://youtu.be/ftQKz7jg_U4',
    videoTitle: 'SuperOne Trailer German',
    description: `SuperOne ist ein Unternehmen, das über sieben Jahre an einem einzigartigen Online-Produkt gearbeitet hat – mit dem Ziel, ein weltweit skalierbares Quiz-Game zu schaffen.
Im Kern ist SuperOne ein Wissensspiel, vergleichbar mit „Wer wird Millionär?“, jedoch mit einem entscheidenden Unterschied: Es richtet sich an die größte und leidenschaftlichste Community der Welt – Fußballfans.
Weltweit gibt es rund fünf Milliarden Fußballbegeisterte. Etwa eine Milliarde davon fühlt sich ihrem Lieblingsverein emotional stark verbunden.
Genau hier setzt SuperOne an: Spieler können jeden Sonntag durch ihr Wissen über ihren Lieblingsclub Preisgelder von bis zu einer Million Dollar gewinnen.
Die Kombination aus Fußball, Gamification und außergewöhnlich hohen Gewinnsummen schafft das Potenzial, Super One in kurzer Zeit zu einem der meistgespielten Online-Games weltweit zu machen.`,
  },
  {
    id: 'prolife',
    title: 'ProLife',
    image: `${ASSETS}/9qv3gkg6_Prolife.jpeg`,
    video: 'https://youtu.be/UHwfe37f3AE',
    videoTitle: 'Wir kaufen Ihre Lebensversicherung & Sie erhalten Ihr Geld binnen 18 Tagen!',
    description: `💼 Ordnerchaos ade – mach Platz im Schrank und freu dich auf Bares! 💸
Deine Ordner quellen über vor alten Versicherungen. Lebens-, Renten-, Unfall, Bausparverträge, Rürup- oder Basisrenten. Sind diese rentabel und tatsächlich so sicher, wie es immer dargestellt wird? 😰
Du hast keine Lust, dich damit rumzuärgern oder dich durch den Papierberg zu wühlen. Aber genau da schlummert oft bares Geld, das du dir holen kannst! 💯
Jetzt wird's easy: Gib die Verträge einfach ab. Es wird alles gründlich geprüft und Du kriegst die Infos geschickt und wenn der Fall übernommen wird, erhältst du nach 18 Tagen dein Geld. Fertig 🛫
Endlich die alten Ballaste loswerden, mit kaum Arbeit und das Geld auf deinem Konto freimachen, das dir wirklich gehört. Geld, das du für dich nutzen kannst, ob du es investierst für die Zukunft oder damit die kaputte Waschmaschine reparierst oder die Klassenfahrt vom Kind bezahlst. Total egal, es ist dein Geld auf deinem Konto und du kannst damit machen, was du möchtest. Genial, oder? 🍀
Lasst uns zusammen aufräumen und vorwärtskommen. 💪`,
  },
];

const toEmbed = (url) => {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1].substring(0, 11)}`;
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
};

const ProjectVideo = ({ project }) => {
  const embed = toEmbed(project.video);
  if (embed) {
    return <div className="orbit-video-frame"><iframe src={embed} title={project.videoTitle} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-testid="orbit-video-iframe" /></div>;
  }
  if (project.video) {
    return (
      <div className="orbit-video-frame">
        <video controls preload="metadata" playsInline poster={project.image} controlsList="nodownload" onContextMenu={(e) => e.preventDefault()} data-testid="orbit-video">
          <source src={project.video} type="video/mp4" />
        </video>
      </div>
    );
  }
  return (
    <div className="orbit-video-placeholder" data-testid="orbit-video-placeholder">
      <span className="orbit-video-placeholder-icon"><Film size={26} /></span>
      <strong>{project.videoTitle}</strong>
      <span>Video folgt in Kürze.</span>
    </div>
  );
};

const ProjectDetail = ({ project, onStart }) => (
  <div className="orbit-detail" key={project.id} data-testid="orbit-detail">
    <div className="orbit-detail-text">
      <span className="orbit-detail-kicker">Projekt</span>
      <h3 data-testid="orbit-detail-title">{project.title}</h3>
      <p data-testid="orbit-detail-desc">{project.description}</p>
      <a href="#cta-section" className="orbit-start-btn" onClick={(e) => { e.preventDefault(); onStart(project); }} data-testid={`orbit-start-${project.id}`}>
        <Play size={15} /> Loslegen
      </a>
    </div>
    <div className="orbit-detail-media"><ProjectVideo project={project} /></div>
  </div>
);

export default function ProjectsOrbit() {
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  const handleStart = (project) => {
    window.dispatchEvent(new CustomEvent('rotator-prefill', { detail: { project: project.title } }));
    document.getElementById('cta-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const current = PROJECTS[active];
  return (
    <div className="orbit-wrap" data-testid="projects-orbit">
      <div className={`orbit ${paused ? 'paused' : ''}`} style={{ '--n': PROJECTS.length }} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
        <div className="orbit-ring" aria-hidden="true" />
        <div className="orbit-track">
          {PROJECTS.map((p, i) => (
            <button
              type="button"
              key={p.id}
              className={`orbit-item ${i === active ? 'active' : ''}`}
              style={{ '--i': i }}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => { setActive(i); setPaused(true); }}
              aria-label={p.title}
              aria-pressed={i === active}
              data-testid={`orbit-item-${p.id}`}
            >
              <span className="orbit-item-inner">
                <span className="orbit-item-media"><img src={p.image} alt={p.title} draggable="false" loading="lazy" /></span>
                <span className="orbit-item-label">{p.title}</span>
              </span>
            </button>
          ))}
        </div>
        <div className="orbit-center" key={current.id} data-testid="orbit-center">
          <span className="orbit-center-media"><img src={current.image} alt={current.title} draggable="false" /></span>
          <span className="orbit-center-title">{current.title}</span>
          <span className="orbit-center-hint">{paused ? 'Ausgewählt' : 'Fahre über ein Projekt'}</span>
        </div>
      </div>
      <ProjectDetail project={current} onStart={handleStart} />
    </div>
  );
}
